export const START_DATE = "startDate";
export const END_DATE = "endDate";
export const SELECTED_LABEL = "selectedLabel";
